import React, { useEffect, useState } from "react";
import { GridColumns } from "@mui/x-data-grid";
import SkuHelper from "../../../helper/skuHelper";
import AcompanhamentoCargaItensModalTopo from "./acompanhamentoCargaItensModalTopo";
import AcompanhamentoCargaItensModalDetalhe from "./acompanhamentoCargaItensModalDetalhe";
// import { Data } from "react-csv/components/CommonPropTypes";

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

export default function AcompanhamentoCargaItensModal(
  props: AcompanhamentoCargaItensModalPropTypes
) {
  const { t } = useTranslation();

  const [rows, setRows] = useState<Data>([]);
  const columns: GridColumns = [
    {
      field: "id",
      headerName: t("common.id"),
      width: 80,
      align: "center",
      headerAlign: "center",
      renderHeader: (item) => {
        return <div>#</div>;
      },
    },
    {
      field: "item",
      headerName: t("common.item"),
      type: "string",
      width: 110,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "sku",
      headerName: t("common.sku"),
      type: "string",
      width: 110,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "descricaoSku",
      headerName: t("common.skuDescriptio"),
      type: "string",
      width: 400,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return <div>{SkuHelper.getSKUName(item.row.sku)}</div>;
      },
    },
    {
      field: "quantidade",
      headerName: t("common.orderQuantity"),
      type: "string",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <p>
            {item.value ? item.value?.toString()?.replace('.', ',') : ""}
          </p>
        );
      },
    }
  ];

  const fillTable = () => {
    let gridData: Data = [];
    props.data?.itens?.forEach(
      (item: any, index: number) => {
        item.id = index;
        gridData.push(item);
      }
    );
    setRows(gridData);
  }

  useEffect(() => {
    fillTable();
  }, [props.data])

  return (
    <div className="containerForecastModal" style={{ width: "80vw" }}>
      <div className="containerTitleModal">
        <AcompanhamentoCargaItensModalTopo
          pedido={props.data?.pedido}
        />
      </div>
      <div className="insiderContainerModal">
        <AcompanhamentoCargaItensModalDetalhe
          handleClose={props.handleClose}
          data={rows}
          columns={columns}
        />
      </div>
    </div>
  );
}

interface AcompanhamentoCargaItensModalPropTypes {
  handleClose: any,
  data: any
}
